














import { Component, Prop, Vue } from "vue-property-decorator";
import { CPTDataI } from "@/models/cpt/CPTModel";
import { CPTState } from "@/models/cpt/CPTState";

@Component
/**
 * Displays a single edit button decide to reopen a cpt
 * or just redirect to the moderate view
 */
export default class ModerateSubmissionBtn extends Vue {
  /**
   * The cpt that needs to go into moderation
   */
  @Prop({ required: true }) readonly cpt!: CPTDataI;

  /**
   * define if a cpt can be moderated
   * @param state
   */
  public showModerateBtn(state: string): boolean {
    return (
      state === CPTState.PROPOSED ||
      state === CPTState.PUBLISHED ||
      state === CPTState.REJECTED
    );
  }
  /**
   * reopen and or navigate to moderate view
   */
  public async moderateCpt(): Promise<void> {
    await this.$router.push({
      name: "moderateCPT",
      params: { cpt: this.cpt.type, id: this.cpt.id },
    });
  }
}
